/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_li_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate placeholder text`)
};

const es_li_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera texto de marcador`)
};

const de_li_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platzhaltertext generieren`)
};

const nl_li_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genereer plaatsaanduidingstekst`)
};

const fr_li_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générer du texte de remplissage`)
};

const it_li_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera testo placeholder`)
};

const pt_br2_li_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerar texto de espaço reservado`)
};

const pt_li_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gere texto espaço reservado`)
};

const ja_li_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレースホルダーテキストを生成`)
};

const zh_li_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成占位文本`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const li_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.li_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("li_nav_main_desc", locale)
	if (locale === "en") return en_li_nav_main_desc(inputs)
	if (locale === "es") return es_li_nav_main_desc(inputs)
	if (locale === "de") return de_li_nav_main_desc(inputs)
	if (locale === "nl") return nl_li_nav_main_desc(inputs)
	if (locale === "fr") return fr_li_nav_main_desc(inputs)
	if (locale === "it") return it_li_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_li_nav_main_desc(inputs)
	if (locale === "pt") return pt_li_nav_main_desc(inputs)
	if (locale === "ja") return ja_li_nav_main_desc(inputs)
	return zh_li_nav_main_desc(inputs)
};